import { topbarOnScroll } from './Topbar';
import {
  showHideMenu,
  loadAcademyMenuV2,
  // loadEnterpriseMenu,
  showHideAcademyMenu,
  hideAcademyMenu,
} from './Menu';
import { loadDrawer, drawerOnToggle } from './Drawer';
import { showHideLanguage } from './Language';

const init = () => {
  loadDrawer();
  drawerOnToggle();
  loadAcademyMenuV2();
  // loadEnterpriseMenu();
  topbarOnScroll();
  showHideMenu();
  showHideLanguage();
  showHideAcademyMenu();
  hideAcademyMenu();
};

export default init;

export { topbarOnScroll, showHideMenu, showHideLanguage };
